"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var UserIcon = function UserIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#333F48' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6665 9.99984C1.6665 5.48234 5.48234 1.6665 9.99984 1.6665C14.5173 1.6665 18.3332 5.48234 18.3332 9.99984C18.3332 12.6582 17.0065 15.0648 14.9998 16.6032V16.6665H14.9148C13.5248 17.704 11.8223 18.3332 9.99984 18.3332C8.17734 18.3332 6.47484 17.704 5.08484 16.6665H4.99984V16.6032C2.99317 15.0648 1.6665 12.6573 1.6665 9.99984ZM9.1665 13.8107C7.97317 13.8107 6.97567 14.6515 6.72817 15.7723C7.7015 16.3365 8.81984 16.6665 9.99984 16.6665C11.1798 16.6665 12.2982 16.3365 13.2715 15.7723C13.024 14.6523 12.0265 13.8107 10.8332 13.8107H9.1665ZM10.8332 12.144C12.5598 12.144 14.044 13.2007 14.6748 14.7007C15.8973 13.4848 16.6665 11.8132 16.6665 9.99984C16.6665 6.38567 13.614 3.33317 9.99984 3.33317C6.38567 3.33317 3.33317 6.38567 3.33317 9.99984C3.33317 11.8132 4.10234 13.4848 5.32484 14.7007C5.95484 13.2015 7.43984 12.144 9.1665 12.144H10.8332ZM6.6665 8.33321C6.6665 6.43321 8.09984 4.99988 9.99984 4.99988C11.8998 4.99988 13.3332 6.43321 13.3332 8.33321C13.3332 10.2332 11.8998 11.6665 9.99984 11.6665C8.09984 11.6665 6.6665 10.2332 6.6665 8.33321ZM8.33317 8.33321C8.33317 9.31488 9.01817 9.99988 9.99984 9.99988C10.9815 9.99988 11.6665 9.31488 11.6665 8.33321C11.6665 7.35154 10.9815 6.66654 9.99984 6.66654C9.01817 6.66654 8.33317 7.35154 8.33317 8.33321Z",
    fill: color
  }));
};
var _default = UserIcon;
exports.default = _default;